const DIALECT_CODE_MAP = {
  en_US: 'en-US',
  en_GB: 'en-GB',
  pt_PT: 'pt-PT',
  pt_BR: 'pt-BR',
  zh_Hans: 'zh-Hans',
  zh_Hant: 'zh-Hant',
  sr_Latn: 'sr-Latn',
  sr_Cyrl: 'sr-Cyrl',
}

// Store lookup keys in lowercase so languageName.toLowerCase() matches,
// but keep the original-cased labels for display lookups.
export const dialectToCodeMap = new Map([])

export const codeToDialectMap = new Map([])

export function setDialectMaps(dialects = {}) {
  dialectToCodeMap.clear()
  codeToDialectMap.clear()

  for (const [key, code] of Object.entries(DIALECT_CODE_MAP)) {
    const label = dialects[key]
    if (label) {
      dialectToCodeMap.set(label.toLowerCase(), code)
      codeToDialectMap.set(code, label)
    }
  }
}
